import { cn } from "design-system/utils"
import { CapabilityCard } from "modules/capabilities/components/List/CapabilityCard"
import { EmptyState } from "modules/capabilities/components/List/EmptyState"
import { CapabilitiesMarketplaceResponseDataSchema, CapabilitiesResponseDataSchema } from "schema"
import z from "zod"

type CapabilitiesListContentProps = {
  capabilities:
    | z.infer<typeof CapabilitiesResponseDataSchema>
    | z.infer<typeof CapabilitiesMarketplaceResponseDataSchema>
  tab: "installed" | "marketplace"
  onChangeTab: (tab: "installed" | "marketplace") => void
  search: string
  edit?: string
  install?: string
}

export function CapabilitiesListContent({
  capabilities,
  tab,
  onChangeTab,
  search,
}: CapabilitiesListContentProps) {
  return (
    <>
      {capabilities.length > 0 && (
        <div
          className={cn(
            "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4",
            tab === "marketplace" && "2xl:grid-cols-3",
          )}
        >
          {capabilities.map((capability) => (
            <CapabilityCard
              key={"id" in capability ? capability.id : capability.identifier}
              capability={capability}
            />
          ))}
        </div>
      )}
      {capabilities.length === 0 && (
        <EmptyState tab={tab} onChangeTab={onChangeTab} search={search} />
      )}
    </>
  )
}
